<div class="h-100 text-center welcome-page">
  <div class="w-header">
  </div>
  <!-- <div class="modal-icon">
    <img src="../../../../assets/chatbotImages/avatar.png" alt="ICON" />
  </div> -->
  <h1 class="para-title">The Tabitha Initiative</h1>
  <p class="para-body">
    This is a private technology effort
    to connect families directly with hunger
    relief donors this covid-19 period.
    <br>
    <span class="flex mt-2 justify-center">
      No family must be left behind!
    </span>
  </p>

  <button style="cursor: pointer" (click)="gotoReceiver()" id="welcomeButton" class="ui button primary basic mt-4">
    My family needs help
  </button>
  <a style="cursor: pointer" class="mt-3 link" (click)="gotoGiver()">I want to help a family</a>
</div>